// config
import * as http from 'utils/http';
import config from 'config';

const getCarriers = async (...args) => {
  const queryParams = args[0].replace('carriers/', '');
  const extraQueryParams = '';
  const endpoint = `${config.API_URL}carriers/${queryParams}&${extraQueryParams}`;
  const data = await http.get(`${endpoint}`);
  return data.results;
};

export default getCarriers;
